SupportTicketSuccessView = require('./ticket_success_view')

class SupportChatSuccessView extends SupportTicketSuccessView

  toHash: ->
    hash =
      showDefaultThankYouMsg: false
      showChatThankYouMsg:  true
      showNeedHelpLink: true
      showFooter: false
      greeting_text: @getGreetingText()
      isChatFlow: true
    hash

  getGreetingText: () ->
    I18n.translate('js.modules.support.v2.thanks_chat')

module.exports = SupportChatSuccessView
